import axios from "axios";
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export default function(opts = {}) {

    const APP_STATEKEY = "APP_SEARCH";

    return {
        isMobile: false,
        timer: false,
        workLoading: false,
        newsLoading: false,
        workResults: [],
        newsResults: [],
        searchedQ: '',
        forceLoading: false,
        isModal: false,
        _abortController: null,
        page: 1,
        hasMore: false,

        get loading() {
            return this.workLoading || this.newsLoading;
        },

        init() {

            this.searchQ = opts.q;
            this.searchSection = (opts.section && opts.section !== 'false') ? opts.section : null;
            this.isModal = opts.modal;

            window.onpopstate = (e) => {
                const { state } = e;

                if (!state) {
                    window.location.href = window.location.href;
                    return;
                }

                const { _uid, q, stateKey } = state;

                if (stateKey !== APP_STATEKEY) {
                    // it's someone else's state...leave it alone.
                    return;
                }

                if (_uid !== this._uid) {
                    window.location.href = window.location.href;
                    return;
                }

                if (this.isModal && q) {
                    this.searchShow = true;
                    this.searchQ = q;
                    this.search(false);
                } else {
                    this.searchShow = false;
                }
            }

            this.$watch('searchShow', val => {
              if (this.searchShow && this.isModal) {
                  this.$refs.search.focus();
                  document.body.classList.add('overflow-hidden');
              } else if (this.isModal) {
                  document.body.classList.remove('overflow-hidden');
              }
            });

            this.searchedQ = this.searchQ;
            history.replaceState(this.getState(), this.title, window.location.href);

            if (`${this.searchedQ}`.trim() && (!this.isModal || (this.isModal && this.searchShow))) {
                this.search(false);
            }
        },

        async search(push = true) {
            if (!`${this.searchQ}`.trim()) return;

            let query = this.searchQ;
            clearTimeout(this.timer);

            if (this._abortController) {
                this._abortController.abort();
            }
            this._abortController = new AbortController();

            this.workResults = [];
            this.newsResults = [];
            this.page = 1;
            this.hasMore = false;

            const showWork = !this.searchSection || this.searchSection === 'work';
            const showNews = !this.searchSection || this.searchSection === 'news';

            if (showWork) {
                this.workLoading = true;

                const { data: workResponse } = await axios.get('/search.json', {
                    signal: this._abortController.signal,
                    params: { q: query, section: 'work' },
                }).catch(err => {
                    if (axios.isCancel(err)) return { data: null };
                    this.workLoading = false;
                    return { data: null };
                });

                if (!workResponse || this.searchQ !== query) return;
                this.workLoading = false;

                if (workResponse.data) {
                    this.workResults = [...workResponse.data];
                }
            }

            if (showNews) {
                this.newsLoading = true;

                const { data: newsResponse } = await axios.get('/search.json', {
                    signal: this._abortController.signal,
                    params: { q: query, section: 'news', page: 1 },
                }).catch(err => {
                    if (axios.isCancel(err)) return { data: null };
                    this.newsLoading = false;
                    return { data: null };
                });

                if (!newsResponse || this.searchQ !== query) return;
                this.newsLoading = false;

                if (newsResponse.data) {
                    this.newsResults = [...newsResponse.data];
                    this.hasMore = !!newsResponse.meta?.pagination?.links?.next;
                }
            }

            this.searchedQ = query;
            if (push) this.pushState();
        },

        async loadMore() {
            if (this._abortController) {
                this._abortController.abort();
            }
            this._abortController = new AbortController();

            this.page = this.page + 1;
            this.newsLoading = true;

            const { data: response } = await axios.get('/search.json', {
                signal: this._abortController.signal,
                params: { q: this.searchQ, section: 'news', page: this.page },
            }).catch(err => {
                if (axios.isCancel(err)) return { data: null };
                this.newsLoading = false;
                return { data: null };
            });

            this.newsLoading = false;

            if (!response) return;

            const { data, meta } = response;

            if (data) {
                this.newsResults = [...this.newsResults, ...data];
                this.hasMore = !!meta?.pagination?.links?.next;
            }
        },

        maybeSearch() {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                this.search();
            }, 400);
        },

        getState() {
            return { _uid: this._uid, q: this.searchedQ, section: this.searchSection, stateKey: APP_STATEKEY };
        },

        pushState() {
            const url = `/search?q=${this.searchQ}${this.searchSection ? `&section=${this.searchSection}` : ''}`;
            history.pushState(this.getState(), this.title, url);
        },

        showOnly(section) {
            this.searchSection = section;
            if (this.searchedQ) {
                this.search();
            }
        },

        get title() {
            if (this.searchedQ) {
                return `Searched for "${this.searchedQ}"`;
            }

            return "Looking for something?";
        },
    }
}
